import { useMutation } from "@tanstack/react-query";
import { generateCode, loginWithCode, updatePassword } from "./loginApi";

export function useGenerateCodeQuery() {
  return useMutation({
    mutationFn: ({ email, loginUrl }: { email: string; loginUrl?: string }) =>
      generateCode(email, loginUrl),
  });
}

export function useLoginWithCodeQuery() {
  return useMutation({
    mutationFn: ({
      clientUuid,
      email,
      code,
    }: {
      clientUuid: string;
      email: string;
      code: string;
    }) => loginWithCode(clientUuid, email, code),
  });
}

export function useUpdatePasswordMutation() {
  return useMutation({
    mutationFn: ({ email, password }: { email: string; password: string }) =>
      updatePassword(email, password),
  });
}
